export default __webpack_public_path__ + "static/media/p4_token.885cab68.png";